module.exports = __webpack_public_path__ + "img/photo-car.a8134fbf.png";